<div class="container" fxLayout="row">
  <optsol-ngx-login-form class="os-m-auto" (formSubmit)="attempt($event)" [disableSubmitButton]="false" fxFlex="40%">
      <img brandImage [src]="'assets/images/logo.png'" width="50%" />
      <span title class="mat-h2">Customer Portal</span>
      <img poweredByImage [src]="'assets/images/optsol.png'" />
      <ng-container links>
          <a [routerLink]="['/forgot-password']">Forgot Password?</a>
      </ng-container>
  </optsol-ngx-login-form>
</div>